//import node_modules
import React, { FunctionComponent } from "react";
import NextImage from "next/legacy/image";
import Link from "next/link";
import { Col } from "react-bootstrap";

//libs
import getBootstrapSizes from "@adjust/website/libs/helper/getBoostrapSizes";
import { css } from "libs/emotion";

//types
import type { BlogDocument } from "@adjust/libs/database/blogs";

const sizes = getBootstrapSizes({ xs: 640, lg: 384, xxl: 640 });

type BlogPreviewProps = {
  blog: BlogDocument;
  order: number;
  index: number;
};

function getLoading(index: number): "eager" | "lazy" | undefined {
  if (index === 0) return undefined;
  return "lazy";
}

const imageWrapperCSS = css({
  display: "block",
  position: "relative",
  margin: "16px",
  width: "100%",
  height: "362px",
  maxHeight: "90vw",
  overflow: "hidden",
  borderRadius: "0.5rem",
  transition: "opacity 0.15s",
});

const imageCSS = css({
  transition: "opacity 0.15s",
  backgroundColor: "#e5e7eb",
  [":hover"]: {
    opacity: 0.7,
  },
});

const ImageComponent: FunctionComponent<BlogPreviewProps> = ({ blog, index, order }) => {
  return (
    <Col className="d-flex" xs={{ order: 1, span: 12 }} lg={{ order: order, span: 5 }}>
      <Link href={`/blog/${blog.slug}`} className={imageWrapperCSS}>
        <NextImage
          src={blog.image.src}
          alt={blog.title}
          className={imageCSS}
          sizes={sizes}
          quality={50}
          priority={index === 0}
          loading={getLoading(index)}
          layout="fill"
          objectFit="cover"
          blurDataURL={blog.image.blurDataURL}
          placeholder="blur"
          lazyBoundary="362px"
        />
      </Link>
    </Col>
  );
};

export default React.memo(ImageComponent);
